// extracted by mini-css-extract-plugin
export default {"separator":"Copyright_separator__Bbd3v","copyright":"Copyright_copyright__6yFsl"};